import type { GetTokenSilentlyOptions } from '@auth0/auth0-react';

type AccessTokenOptions = Omit<GetTokenSilentlyOptions, 'detailedResponse'> & {
  detailedResponse?: false;
};

export async function getAuthAccessToken(options: AccessTokenOptions = {}) {
  return (await window.getAccessTokenSilently(options)) as string;
}

export function getAuthorizationHeader(accessToken: string) {
  return `Bearer ${accessToken}`;
}
